import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

import { LayoutModule } from './layouts/layout.module';
import { ThemeRoutingModule } from './theme-routing.module';
import { ThemeComponent } from './theme.component';
import {
    LesseeEditComponent, LesseeNewComponent, LesseesListComponent
} from './pages/aside-left-display-disabled/lessees';
import { ActionButtonModule } from '../shared/action-button';
import { DatePickerModule } from '../shared/date-picker';
import { ContainerModule } from '../shared/container';
import { ListContainerModule } from '../shared/list-container';
import { SelectModule } from '../shared/select';
import { TableModule } from '../shared/table';

@NgModule({
    declarations: [
        ThemeComponent,
        LesseeEditComponent,
        LesseeNewComponent,
        LesseesListComponent
    ],
    imports: [
        CommonModule, LayoutModule, ThemeRoutingModule, TableModule, ActionButtonModule,
        DatePickerModule, ContainerModule, ListContainerModule, FormsModule, ReactiveFormsModule,
        SelectModule, SweetAlert2Module.forRoot()
    ], exports: [
        RouterModule
    ]
})
export class ThemeModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/theme.module.ts